import { filter } from "lodash";
import CalendarColumn from "./calendarColumn";

const CalendarColumns = ({
  OFFSET_LEFT,
  date,
  slots,
  sessions,
  columnWidth,
}) => {
  return sessions.map((session, columnIndex) => {
    const assignedSlots = filter(
      slots,
      (slot) => slot?.assignedSession === session?.sessionId,
    );

    return (
      <CalendarColumn
        date={date}
        session={session}
        key={session?.sessionId}
        OFFSET_LEFT={OFFSET_LEFT}
        columnIndex={columnIndex}
        columnWidth={columnWidth}
        reviewsToday={assignedSlots}
      />
    );
  });
};

export default CalendarColumns;
